import store from '@/store'

export default async (to, from, next) => {
    console.log(store.getters.user.hasCurlProfile)
    if (store.getters.user.hasCurlProfile) {
        next({ name: 'Dashboard' })
    } else {
        next()
    }
}


// WEBPACK FOOTER //
// ./src/middleware/hasCurlProfile.js